import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MacAddressFormComponent } from './components/mac-address-form/mac-address-form.component';

const routes: Routes = [
  {
    path : '',
    component : MacAddressFormComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MacAddressRoutingModule { }
